import React, { useEffect } from 'react';
import { subscriptionApi } from '../utils/apiUtils';

const ChangeSubscription = () => {
	useEffect(() => {
		const redirectToPortal = async () => {
			try {
				const response = await subscriptionApi.createPortalSession();
				if (response.url) window.location.href = response.url;
			} catch (error) {
				console.error('Error redirecting to portal:', error);
			}
		};
		redirectToPortal();
	}, []);

	return (
		<div className="flex flex-col items-center justify-center min-h-[60vh]">
			<div className="w-8 h-8 border-2 border-white/15 border-t-yellow-300 rounded-full animate-spin mb-5" />
			<h2 className="text-sm text-white/50 text-center font-medium">
				Redirecting to customer portal...
			</h2>
		</div>
	);
};

export default ChangeSubscription;
